var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReboot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 2.91663V4.99996H12.9167C12.2267 4.99996 11.6667 5.55996 11.6667 6.24996C11.6667 6.93996 12.2267 7.49996 12.9167 7.49996H15.8334C16.7542 7.49996 17.5001 6.75413 17.5001 5.83329V2.91663C17.5001 2.22663 16.9401 1.66663 16.2501 1.66663C15.5601 1.66663 15.0001 2.22663 15.0001 2.91663Z",
    fill: "#6C6C6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27998 8.83164C4.72415 6.54164 6.57831 4.70331 8.87081 4.27248C10.945 3.88331 12.8683 4.59497 14.1666 5.92164V5.83331H17.2091C15.6383 3.12248 12.5916 1.37248 9.16331 1.70748C5.30581 2.08414 2.14581 5.19748 1.71915 9.04914C1.68415 9.36998 1.66748 9.68664 1.66748 9.99998H4.17498C4.17498 9.61748 4.20331 9.22831 4.27998 8.83164Z",
    fill: "#6C6C6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 18.3333C14.1058 18.3333 17.5183 15.3633 18.2066 11.455C18.34 10.7 17.7833 10 17.0166 10H16.9391C16.3333 10 15.8475 10.4525 15.7391 11.0483C15.245 13.77 12.8633 15.8333 9.99998 15.8333C6.77915 15.8333 4.17581 13.2208 4.17498 10H1.66748C1.66748 14.6025 5.39748 18.3333 9.99998 18.3333Z",
    fill: "#DBDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReboot);
export default __webpack_public_path__ + "static/media/ic-reboot.942301938aac8ce3c7d1c00eab5116b3.svg";
export { ForwardRef as ReactComponent };